<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        :title="form.xjname || '个人信息'"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack(form.id ? ('/stu-main/'+ form.id) : '/')"
      />
      <div class="form-info" style="padding-bottom:50px;">
        <van-form @submit="onSubmit" @failed="onFailed" ref="form">
          <van-cell-group title="个人信息">
            <van-cell title="姓名" :value="form.name" />
            <van-cell title="性别" :value="form.sexname" />
            <van-cell v-if="!canEdit.sfzh" title="身份证号" :value="form.sfzh" />
            <van-field
              v-if="canEdit.sfzh"
              v-model="form.sfzh"
              name="sfzh"
              label="身份证号"
              placeholder="身份证号"
              :rules="[{ required: true, validator: (value, rule) => {
                  if (value) {
                    let m = value.match(/^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/);
                    return m ? true : false;
                  }
                  return true
                }, 
                //pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
                message: '请填写正确的身份证号' }]"
              input-align="right"
            />
            <van-cell v-if="!canEdit.mobile" title="手机号" :value="form.mobile" />
            <van-field
              v-if="canEdit.mobile"
              type="number"
              v-model="form.mobile"
              name="mobile"
              label="* 手机号"
              placeholder="手机号"
              :rules="[{ required: true, pattern:/^1[3456789]\d{9}$/, message: '请填写正确的手机号' }]"
              input-align="right"
            />
            <van-cell v-if="!canEdit.weixin" title="微信号" :value="form.weixin" />
            <van-field
              v-if="canEdit.weixin"
              v-model="form.weixin"
              name="weixin"
              label="微信号"
              placeholder="微信号"
              :rules="[{ required: true, message: '请填写微信号' }]"
              input-align="right"
            />
            <van-cell v-if="!canEdit.qq" title="QQ" :value="form.qq" />
            <van-field
              v-if="canEdit.qq"
              v-model="form.qq"
              name="qq"
              label="QQ"
              placeholder="QQ"
              :rules="[{ required: false, message: '请填写QQ' }]"
              input-align="right"
            />
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.mzname"
              label="民族"
              :placeholder="form.mzname ? '点击选择民族' : ''"
              @click="showMz = true"
              :rules="rules.mzname"
              input-align="right"
            />
            <van-popup v-model="showMz" position="bottom">
              <van-picker
                show-toolbar
                :columns="mzList"
                value-key="name"
                @confirm="onConfirmMz"
                @cancel="showMz = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.zzmmname"
              label="政治面貌"
              :placeholder="form.zzmmname ? '点击选择政治面貌' : ''"
              @click="showZzmm = true"
              :rules="rules.zzmmname"
              input-align="right"
            />
            <van-popup v-model="showZzmm" position="bottom">
              <van-picker
                show-toolbar
                :columns="zzmmList"
                value-key="name"
                @confirm="onConfirmZzmm"
                @cancel="showZzmm = false"
              />
            </van-popup>
            <!-- <van-field name="bodystate" label="身体状况"
              :rules="[{ required: true, message: '请选择' }]"
              input-align="right"
            >
              <template #input>
                <van-radio-group v-model="form.bodystate" direction="horizontal">
                  <template v-for="(v, k) in bodystate">
                    <van-radio :key="k" :name="k">{{ v }}</van-radio>
                  </template>
                </van-radio-group>
              </template>
            </van-field> -->
            <!-- <van-field name="hjtype" label="户籍类型"
              :rules="[{ required: true, message: '请选择' }]"
              input-align="right"
            >
              <template #input>
                <van-radio-group v-model="form.hjtype" direction="horizontal">
                  <template v-for="(v, k) in hjType">
                    <van-radio :key="k" :name="k">{{ v }}</van-radio>
                  </template>
                </van-radio-group>
              </template>
            </van-field> -->
            <!-- <van-field
              v-if="canEdit.hjd"
              v-model="form.hjd"
              name="hjd"
              label="户籍地"
              placeholder="填写户籍地"
              :rules="[{ required: false, message: '请填写户籍地' }]"
              input-align="right"
            /> -->
            <!-- <van-cell v-if="!canEdit.hjd" title="户籍地" :value="form.hjd" /> -->
            <!-- <van-cell v-if="!canEdit.sfzdz" title="户籍地址" :value="form.sfzdz" /> -->
            <!-- v-if="canEdit.sfzdz" -->
            <van-field
              v-model="form.sfzdz"
              name="sfzdz"
              label="户籍地址"
              placeholder="填写户籍地址"
              :rules="[{ required: false, message: '请填写户籍地址' }]"
              input-align="right"
            />
            <van-field
              v-model="form.address"
              name="address"
              label="邮寄地址"
              placeholder="填写邮寄地址"
              :rules="[{ required: false, message: '请填写邮寄地址' }]"
              input-align="right"
            />
            <van-field
              v-model="form.workunit"
              name="workunit"
              label="工作单位"
              placeholder="填写工作单位"
              :rules="[{ required: false, message: '请填写工作单位' }]"
              input-align="right"
            />
            <van-field
              v-model="form.jjlxdh"
              name="jjlxdh"
              label="紧急联系电话"
              placeholder="填写紧急联系电话"
              :rules="[{ required: false, message: '请填写紧急联系电话' }]"
              input-align="right"
            />
            <!-- <van-field name="uploader" label="免冠寸照" input-align="right">
              <template #input>
                <van-uploader v-model="form._pic" :after-read="afterRead" :max-count="1" />
              </template>
            </van-field> -->
            <van-field name="uploader" label="身份证正面" input-align="right">
              <template #input>
                <van-uploader v-model="form._sfzpic" :after-read="afterRead" :max-count="1" />
              </template>
            </van-field>
            <van-field name="uploader" label="身份证反面" input-align="right">
              <template #input>
                <van-uploader v-model="form._sfzpic2" :after-read="afterRead" :max-count="1" />
              </template>
            </van-field>
          </van-cell-group>
          <div class="signup-btns">
            <van-button round block type="info" native-type="submit" :loading="saveLoading" loading-text="更新中...">
              确定更新
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    id: String
  },
  data() {
    return {
      isLoading: false,
      showMz: false,
      showZzmm: false,
      form: {_pic:[], _sfzpic:[], _sfzpic2:[]},
      canEdit: {},
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      reloadWeb: [types.OTHER.reloadWeb],
      sexList: [types.BASE_LOAD.sexList],
      mzList: [types.BASE_LOAD.mzList],
      zzmmList: [types.BASE_LOAD.zzmmList],
      bodystate: [types.BASE_LOAD.bodystate],
      hjType: [types.STATUS.hjType],
    }),
    defaultData() {
      return {
        id: null,
        name: null,
        sex: null,
        sfzh: null,
        mobile: null,
        qq: null,
        weixin: null,
        mz: null,
        zzmm: null,
        bodystate: null,
        hjdtype: null,
        hjd: null,
        sfzdz: null,
        address: null,
        jjlxdh: null,
        _pic: [],
        _sfzpic: [],
        _sfzpic2: [],
        note: null,
      }
    },
    rules() {
      return {
        mzname: [{ required: true, message: '请选择民族' }],
        zzmmname: [{ required: true, message: '请选择政治面貌' }],
        /*yxname: [{ required: true, message: '请选择院校' }],
        zyname: [{ required: true, message: '请选择专业' }]*/
      }
    }
  },
  watch: {
    reloadWeb() {
      this.loadData();
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(callback) {
      if (!this.sexList || !this.sexList.length) {
        this.$store.dispatch(types.BASE_LOAD.sexList);
      }
      if (!this.mzList || !this.mzList.length) {
        this.$store.dispatch(types.BASE_LOAD.mzList);
      }
      if (!this.zzmmList || !this.zzmmList.length) {
        this.$store.dispatch(types.BASE_LOAD.zzmmList);
      }
      if (!this.bodystate || !Object.keys(this.bodystate).length) {
        this.$store.dispatch(types.BASE_LOAD.bodystate);
      }
      if (!this.hjType || !Object.keys(this.hjType).length) {
        this.$store.dispatch(types.STATUS.hjType);
      }
      if (!this.id) {
        this.form = Object.assign({}, this.defaultData);
        this.Toast.fail('参数错误！');
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.isLoading = true;
      this.canEdit = {};
      this.doPost({
        url: 'site/home/getStu/'+ this.id,
        data: {},
        okcb: (json) => {
          this.form = Object.assign({}, this.defaultData, json, {
            _pic: json.pic ? [{
              url: this.imgPath(json.pic), status: 'done'
            }] : [],
            _sfzpic: json.sfzpic ? [{
              url: this.imgPath(json.sfzpic), status: 'done'
            }] : [],
            _sfzpic2: json.sfzpic2 ? [{
              url: this.imgPath(json.sfzpic2), status: 'done'
            }] : [],
            hjtype: json.hjtype || '0',
            rollList: null
          });
          Object.keys(json).forEach(d => {
            if (!json[d]) {
              this.$set(this.canEdit, d, true);
            }
          });
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
          this.Toast.clear();
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    onConfirmMz(data) {
      this.form.mz = data.id;
      this.form.mzname = data.name;
      this.showMz = false;
    },
    onConfirmZzmm(data) {
      this.form.zzmm = data.id;
      this.form.zzmmname = data.name;
      this.showZzmm = false;
    },
    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      this.doUpload4Vant({
        url: this.upload4Web,
        file: file.file,
        okcb: (json) => {
          file.status = 'done';
          file.url = json.pic;
          //console.log(json, file)
        },
        errcb: (json) => {
          //console.log(json)
          file.status = 'failed';
          file.message = json.message || '上传失败！';
        }
      });
    },
    onSubmit(values) {
      let postData = deepCopy(this.form);
      if (postData.sfzh) {
        postData.sfzh = postData.sfzh.toUpperCase();
      }

      postData.hjtype = parseInt(postData.hjtype);

      if (postData._pic.length) {
        if (!postData._pic[0].url.startWith('http') && !postData._pic[0].url.startsWith('/')) {
          postData.pic = postData._pic[0].url;
        }
      } else {
        postData.pic = null;
      }
      if (postData._sfzpic.length) {
        if (!postData._sfzpic[0].url.startWith('http') && !postData._sfzpic[0].url.startsWith('/')) {
          postData.sfzpic = postData._sfzpic[0].url;
        }
      } else {
        postData.sfzpic = null;
      }
      if (postData._sfzpic2.length) {
        if (!postData._sfzpic2[0].url.startWith('http') && !postData._sfzpic2[0].url.startsWith('/')) {
          postData.sfzpic2 = postData._sfzpic2[0].url;
        }
      } else {
        postData.sfzpic2 = null;
      }

      delete postData._pic;
      delete postData._sfzpic;
      delete postData._sfzpic2;

      // console.log(postData)

      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/home/updateStu',
        data: postData,
        okcb: (json) => {
          this.Dialog.confirm({
            message: '更新成功！',
            showCancelButton: false
          }).then(() => {
            setTimeout(() => {
              this.triggerWeb();
              setTimeout(() => {
                this.loadData();
              }, 3000);
            }, 100);
          });
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            this.Toast.fail(json.message);
          }
        }
      });
    },
    onFailed({ errors }) {
      if (errors.length) {
        this.$refs.form.scrollToField(errors[0].name);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:46px;
  padding-bottom:50px;
  height:calc(100vh - 46px);
  background-color:#f5f5f5;
  /deep/ .van-field__error-message{
    text-align:right;
  }
}
.roll-item{
  padding:1rem;
  background-color:#fff;
}
.roll-item::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
  content: '';
}
.signup-btns {
  position:fixed;
  left: 50%;
  bottom: .2rem;
  width: 100%;
  max-width: 750px;
  transform: translateX(-50%);
  .flex-center-v();
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>